import {Button, Icon} from "antd";
import * as React from 'react';
import {withRouter, RouteComponentProps} from 'react-router';

import JungClient, {Question} from '../../api/JungClient';
import Header from "../../components/Header/Header";

import JungQuestion from '../../components/JungQuestion/JungQuestion';
import {connect, GlobalProps} from '../../stores/GlobalStore';

export interface Answer{
  indice: number,
  letra: string,
}

export interface State{
  questions: Question[],
  answers: string[],
  currentQuestion: number,
  started: boolean,
}

import styles from './JungPage.module.scss';
class JungPage extends React.Component<{} & RouteComponentProps & GlobalProps, State>{

  public state = {
    questions: [],
    answers: Array(28).fill(''),
    currentQuestion: 0,
    started: false
  };

  public render(){

    const { questions, currentQuestion, started } = this.state;

    return (
      <div className={styles.jungPage}>
        <Header page={'Jung'} reloadable={false}/>
        {!started && (
          <div style={{textAlign: 'center'}}>
            <h3>QUESTIONÁRIO DE TIPOLOGIA DE PERSONALIDADE</h3>
            <p>
              <strong>Instruções:</strong>
              A cada pergunta responda de acordo com sua tendência natural e espontânea de ser e de agir e não o modo como
              gostaria de agir.
              Se em alguma você ficar particularmente indeciso, pense na maioria das vezes como reage à situação.
              As perguntas visam unicamente caracterizar alguns elementos de estilos psicológicos - não tem respostas
              certas ou erradas, melhores ou piores.
              Total de 28 questões.  Ao final leia seu perfil de tipologia de personalidade baseado na teoria de Carl Jung.
            </p>
            <Button type="primary" onClick={this.start}>
              Começar <Icon type="check" />
            </Button>
          </div>
        )}

        {started && questions
          .sort((a: Question, b: Question) => a.indice - b.indice)
          .map((question: Question, index: number) =>
          ( currentQuestion === index &&
            <JungQuestion
              question={question}
              key={question._id}
              nextQuestion={this.nextQuestion}
              prevQuestion={this.prevQuestion}
              lastQuestion={index === questions.length - 1}
              onSelectAnswer={this.onSelectAnswer}
              finish={this.finish}
              index={index}
              selectedValue={this.state.answers[index]}
            />
          )
        )}
      </div>
    )
  }

  public async componentDidMount(){
    const {questions} = await JungClient().findAll();

    this.setState({
      questions
    });
  }

  private start = () => {
    this.setState({
      started: true
    });
  };

  private nextQuestion = () => {

    const { currentQuestion, questions } = this.state;

    this.setState({
      currentQuestion: currentQuestion === questions.length - 1? currentQuestion : currentQuestion + 1
    });
  };

  private prevQuestion = () => {

    const { currentQuestion } = this.state;

    this.setState({
      currentQuestion: currentQuestion ? currentQuestion - 1 : 0
    });
  };

  private onSelectAnswer = (answer: Answer) => {
    this.setState({
      answers: replaceAt(this.state.answers, answer.indice - 1, answer.letra)
    });
  };

  private finish = async () => {

    const response = await JungClient().calculateProfile({
      list: this.state.answers,
      token: this.props.authToken
    });

    if(response){
      this.props.history.push('/');
    }
  };

}

function replaceAt(array: any[], index: number, value: string) {
  const ret = array.slice(0);
  ret[index] = value;
  return ret;
}

export default withRouter(connect(JungPage, 'authToken'));
